/** ArollShareModal.tsx — mint / copy / revoke the client share link. */
export const shareModal = {
  // What the client is allowed to do with the cut behind the link.
  // A ladder — each rung includes the one below it.
  'shareModal.accessLabel': 'What they can do',
  'shareModal.accessViewTitle': 'Watch and approve',
  'shareModal.accessViewBody': 'They can play the cut and sign it off. Nothing else — for a cut you consider finished.',
  'shareModal.accessCommentTitle': 'Leave notes and approve',
  'shareModal.accessCommentBody': 'They can leave timecoded notes on the cut and the transcript, then sign off.',
  'shareModal.accessEditTitle': 'Make their own version',
  'shareModal.accessEditBody': 'Everything above, plus making their own version of a cut. Yours only changes if you accept it.',
  /** aria-label on the dialog. */
  'shareModal.dialogAriaLabel': 'Share project',
  'shareModal.title': 'Other links',
  'shareModal.close': 'Close',
  /** Follows the selected rung — the old single line promised "make
   *  their own version" for every link, which stopped being true when
   *  access became a per-link choice. The second sentence is constant:
   *  a share link never exposes the rest of the workspace, whatever it
   *  permits. */
  'shareModal.explainerView':
    'Anyone with the link can watch the cut and approve it. They see only what you have sent this client, and nothing else in your workspace.',
  'shareModal.explainerComment':
    'Anyone with the link can watch the cut, leave notes on it and approve. They see only what you have sent this client, and nothing else in your workspace.',
  'shareModal.explainerEdit': 'Anyone with the link can watch the cut, leave notes, make their own version of a cut and approve. They see only what you have sent this client, and nothing else in your workspace.',
  /** PL▲YBACK has no access ladder — a review link is a review link —
   *  so it gets its own sentence instead of one per rung. */
  'shareModal.explainerPlayback':
    'Anyone with the link can watch this cut, leave notes on it and approve. They see only what you have sent this client, and nothing else in your workspace.',
  /** Heading over the expiry pills, before a link is minted. */
  'shareModal.expiryLabel': 'Link stays live for',
  // Per-link download-original switch (Playback links only).
  'shareModal.downloadLabel': 'Original file',
  'shareModal.downloadOn': 'Downloadable',
  'shareModal.downloadOff': 'Streaming only',
  'shareModal.downloadBody':
    'Downloadable links can save the full-quality file. Streaming only keeps this link to watching and leaving notes.',
  // Per-link range-selects switch (Playback links only). Selects are
  // "use this bit" picks on a cut — a rushes stringout workflow.
  'shareModal.selectsLabel': 'Range selects',
  'shareModal.selectsOn': 'Can mark selects',
  'shareModal.selectsOff': 'Notes only',
  'shareModal.selectsBody':
    'Selects let them mark "use this bit" ranges on the cut — the takes they want in the edit. Turn off to keep this link to notes and approval.',
  'shareModal.expiry7': '7 days',
  'shareModal.expiry30': '30 days',
  'shareModal.expiry90': '90 days',
  'shareModal.expiry365': '1 year',
  /** Row + fresh-link readout. {date} is a localised date. */
  'shareModal.expires': 'Expires {date}',
  'shareModal.copyLink': 'Copy link',
  'shareModal.shownOnce': 'Copy it now. For security the full link is only shown once.',
  'shareModal.creating': 'Creating',
  'shareModal.newLink': 'New link',
  'shareModal.createLink': 'Create link',
  'shareModal.loading': 'Loading…',
  'shareModal.linkCopied': 'Link copied',
  'shareModal.copyFailed': 'Could not copy. Select the link text instead.',
  'shareModal.linkRevoked': 'Link revoked',
  /** Suffix on the row summary; leading separator included. */
  'shareModal.lastOpened': ', last opened {date}',
  /** Suffix on the row summary; leading separator included. */
  'shareModal.notOpenedYet': ', not opened yet',
  'shareModal.revoke': 'Revoke',
  /** Per-link switch (only on projects with A-Roll on): does the
   *  client also see the transcript and paper edit? Off by default. */
  'shareModal.arollLabel': 'A-Roll',
  'shareModal.arollOn': 'Include A-Roll',
  'shareModal.arollOff': 'Cuts only',
  'shareModal.arollBody':
    'Shows the transcript and paper edit beside the cuts. Off keeps this link to review only.',
} as const;
